import { ADDCART, DECREMENT, DELETE, INCRMENT } from "./actionTypes";
import { initialState } from "./initialState";

const cartReducer = (state = initialState, action) => {
 switch (action?.type) {
  case ADDCART:
   const b = state.find((a) => {
    return a.id === action.payload.id;
   });
   if (b !== undefined) {
    return state.map((item) => {
     if (item?.id === b.id) {
      return {
       ...item,
       prodQuantity: item?.prodQuantity + 1,
      };
     }
     return { ...item };
    });
   } else {
    return [...state, action.payload];
   }

  case INCRMENT:
   //  console.log(action.payload);
   return state.map((cartItem) => {
    if (cartItem.id === action.payload.id) {
     //  console.log(cartItem);
     return {
      ...cartItem,
      prodQuantity: cartItem?.prodQuantity + action.payload.value,
     };
    }
    return { ...cartItem };
   });
  case DECREMENT:
   //  console.log(action.payload);
   return state.map((cartItem) => {
    if (cartItem.id === action.payload.id) {
     //  console.log(cartItem);
     return {
      ...cartItem,
      prodQuantity: cartItem?.prodQuantity - action.payload.value,
     };
    }
    return { ...cartItem };
   });
  case DELETE:
   return state.filter((item) => item.id !== action.payload);
  default:
   return state;
 }
};
export default cartReducer;
